import React, { useState, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { trainersData } from "../../core/data/json/trainersData";
import Table from "../../core/common/dataTable/index";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import TrainersModal from "../../core/modals/trainersModal";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import {
  fetchAlltrainer,
  updatetrainer,
  deletetrainerById,
} from "../../core/data/redux/training/trainer/trainerAction";
import DeleteModal1 from "../../core/modals/deleteModal1";
import Select from "react-select";
import { Drawer, message } from "antd";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import { decryptData } from "../../core/utils/encryptUtils";
import { getEmployees } from "../../core/data/redux/employee/employeeAction";

const Trainers = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const { trainer, loading } = useSelector((state: any) => state.training.trainer);
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [iseditDrawerVisible, setIseditDrawerVisible] = useState(false);
  const trainerId = selectedRowData?.Id;
  const [tableKey, setTableKey] = useState(0);
  const [formData, setFormData] = useState<any>({
    Name: "",
    phone: "",
    email: "",
    dob: "",
    address: "",
    description: "",
    status: "",
    trainerType: "Employee",
    instituteName: "",
    modifiedBy: user.UserId,
  });

  const { employees } = useSelector((state: any) => state.employee);
  console.log(employees, 'employees')
  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");



  const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const trainerTypes = [
    { value: "Employee", label: "Employee" },
    { value: "Third_party", label: "Third Party" },
  ];

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (selectedOption: any, field: any) => {
    setFormData({ ...formData, [field]: selectedOption.value });
  };

  const handleEdit = (record: any): void => {
    setIsEditing(true);
    setSelectedRowData(record);

    const formattedDob = record.Dob ? record.Dob.split("T")[0] : "";

    setFormData({
      Name: record.Name,
      phone: record.Phone,
      email: record.Email,
      dob: formattedDob,
      address: record.Address,
      description: record.Description,
      status: record.Status,
      trainerType: record.TrainerType,
      instituteName: record.InstituteName,
      modifiedBy: user.UserId,
    });
  };

  const handleDelete = (trainerId: any) => {
    const id = trainerId;
    dispatch(deletetrainerById({ id }))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.message);
          dispatch(fetchAlltrainer());
        } else {
          setIsDeleteModalVisible(false);
          message.warning(resp.payload.error);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const validateForm = () => {
    let formIsValid = true;
    let newErrors: any = {
      Name: "",
      phone: "",
      email: "",
      dob: "",
      address: "",
      description: "",
      status: "",
      trainerType: "",
      instituteName: "",
    };


    if (!formData.Name.trim()) {
      formIsValid = false;
      newErrors.Name = "Name is required.";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.Name.trim())) {
      formIsValid = false;
      newErrors.Name = "Name should not contain special characters or numbers.";
    }


    if (!formData.phone.trim()) {
      formIsValid = false;
      newErrors.phone = "Phone number is required.";
    } else if (!/^\d{10}$/.test(formData.phone.trim())) {
      formIsValid = false;
      newErrors.phone = "Phone number must be exactly 10 digits.";
    }


    if (!formData.email.trim()) {
      formIsValid = false;
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      formIsValid = false;
      newErrors.email = "Enter a valid email.";
    }


    if (!formData.dob.trim()) {
      formIsValid = false;
      newErrors.dob = "Date of Birth is required.";
    }


    if (!formData.address.trim()) {
      formIsValid = false;
      newErrors.address = "Address is required.";
    }





    if (!formData.status || formData.status === "Select") {
      formIsValid = false;
      newErrors.status = "Status is required.";
    }


    if (!formData.trainerType || formData.trainerType === "Select") {
      formIsValid = false;
      newErrors.trainerType = "Trainer Type is required.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (!validateForm()) return;

    const id = trainerId;

    if (isEditing) {
      dispatch(updatetrainer({ id, data: formData })).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          dispatch(fetchAlltrainer());
          setIseditDrawerVisible(false)
        } else {
          message.warning(res.payload.error);
        }
      });
    }
  };

  useEffect(() => {
    dispatch(fetchAlltrainer());
    dispatch(getEmployees());
  }, [dispatch]);


  const routes = all_routes;
  const data = trainer;

  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { Status: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "Created_at",
      "Created_at",
      selectedSort
    );
  }, [dispatch, trainer, selectedSort, selectedStatus]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, trainer, selectedSort, selectedStatus]);

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          {/* <Link to="#" className="avatar avatar-md border avatar-rounded">
                    <ImageWithBasePath src={`assets/img/users/${record.Image}`} className="img-fluid" alt="img"/>
                </Link> */}
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#">{text}</Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.Name.length - b.Name.length,
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: any, b: any) => a.Phone.length - b.Phone.length,
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: any, b: any) => a.Email.length - b.Email.length,
    },
    {
      title: "Description",
      dataIndex: "Description",
      sorter: (a: any, b: any) => a.Description.length - b.Description.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => {
        const badgeClass =
          text.toLowerCase() === "active"
            ? "badge-success"
            : text.toLowerCase() === "inactive"
              ? "badge-danger"
              : "badge-secondary";

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

          </span>
        );
      },
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          {/* Edit Icon - Always visible, but disabled if canEdit is false */}
          <Link to="#" data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Edit">
            <i
              className="ti ti-edit"
              onClick={() => {
                if (canEdit) {
                  setIsEditing(true);
                  handleEdit(record);
                  setIseditDrawerVisible(true);
                }
              }}
              style={{
                pointerEvents: canEdit ? "auto" : "none",
                cursor: canEdit ? "pointer" : "not-allowed",
                opacity: canEdit ? 1 : 0.5,
              }}
            />
          </Link>

          {/* Delete Icon - Always visible, but disabled if canDelete is false or record is inactive */}
          <Link to="#" data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Delete">
            <i
              className="ti ti-trash"
              onClick={() => {
                if (canDelete && record.Status !== "inactive") {
                  setSelectedRowData(record);
                  setIsDeleteModalVisible(true);
                }
              }}
              style={{
                pointerEvents:
                  canDelete && record.Status !== "inactive" ? "auto" : "none",
                cursor:
                  canDelete && record.Status !== "inactive"
                    ? "pointer"
                    : "not-allowed",
                opacity:
                  canDelete && record.Status !== "inactive" ? 1 : 0.5,
              }}
            />
          </Link>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Trainers</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Training</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Trainers
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canAdd && (
                <div className="mb-2">
                  <Link
                    to="#"
                    className="btn btn-primary d-flex align-items-center"
                    onClick={() => {
                      setIsEditing(false);
                      setIsDrawerVisible(true);
                    }}
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Trainer
                  </Link>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Trainers List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      <TrainersModal
        visible={isDrawerVisible}
        onClose={() => setIsDrawerVisible(false)}
        employees={employees}
      />

      <Drawer
        title="Edit Trainer"
        placement="right"
        onClose={() => setIseditDrawerVisible(false)}
        open={iseditDrawerVisible}
        width={480}
        style={{ marginTop: 50, paddingBottom: 20 }}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Trainer Type <span className="text-danger"> *</span>
                  </label>
                  <select
                    className="form-control"
                    name="trainerType"
                    value={formData.trainerType}
                    onChange={handleChange}
                  >
                    {trainerTypes.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {errors.trainerType && (
                    <div style={{ color: "red" }}>{errors.trainerType}</div>
                  )}
                </div>
                {formData.trainerType === "Third_party" && (
                  <div className="mb-3">
                    <label className="form-label">Institute Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="instituteName"
                      value={formData.instituteName}
                      onChange={handleChange}
                    />
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Name <span className="text-danger">*</span>
                  </label>

                  {formData.trainerType === "Employee" ? (
                    <Select
                      className="select"
                      options={employees.map((emp: any) => ({
                        label: emp.Name,
                        value: emp.EmployeeID,
                      }))}
                      value={
                        employees
                          .map((emp: any) => ({
                            label: emp.Name,
                            value: emp.EmployeeID,
                          }))
                          .find((opt: any) => opt.label === formData.Name) || null
                      }
                      onChange={(selected: any) =>
                        setFormData((prev: any) => ({
                          ...prev,
                          Name: selected.label,
                          phone:
                            employees.find((emp: any) => emp.EmployeeID === selected.value)
                              ?.Phone || "",
                          email:
                            employees.find((emp: any) => emp.EmployeeID === selected.value)
                              ?.email || "",
                        }))
                      }
                      placeholder="Select Employee"
                    />
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      name="Name"
                      value={formData.Name}
                      onChange={handleChange}
                    />
                  )}

                  {errors.Name && <div style={{ color: "red" }}>{errors.Name}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Phone <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                  {errors.phone && (
                    <div style={{ color: "red" }}>{errors.phone}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Email <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <div style={{ color: "red" }}>{errors.email}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Date of Birth <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="dob"
                    value={formData.dob}
                    max={new Date(
                      new Date().setFullYear(new Date().getFullYear() - 18))
                      .toISOString()
                      .split("T")[0]}
                    onChange={handleChange}
                  />
                  {errors.dob && (
                    <div style={{ color: "red" }}>{errors.dob}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Address <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                  {errors.address && (
                    <div style={{ color: "red" }}>{errors.address}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Status <span className="text-danger"> *</span>
                  </label>
                  <Select
                    className="select"
                    options={statusOptions}
                    value={statusOptions.find(
                      (s) => s.value === formData.status
                    )}
                    onChange={(selected: any) =>
                      handleSelectChange(selected, "status")
                    }
                  />
                  {errors.status && (
                    <div style={{ color: "red" }}>{errors.status}</div>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Description
                  </label>
                  <textarea
                    className="form-control"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                  {errors.description && (
                    <div style={{ color: "red" }}>{errors.description}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={() => setIseditDrawerVisible(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
              Update Trainer
            </button>
          </div>
        </form>
      </Drawer>

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id && handleDelete(selectedRowData.Id)
        }
      />
    </>
  );
};

export default Trainers;
